import React from 'react'
import cn from 'classnames'
import { useSelector } from 'react-redux'
import HalfCircleGauge from 'components/HalfCircleGauge'
import { text } from '@groovehq/internal-design-system/lib/styles/elements'
import { selectMailbox } from 'selectors/mailboxes/selectMailbox'
import { selectCurrentTicket } from 'selectors/tickets/current/selectCurrentTicket'
import { styles } from './styles'

const KbScoreHint = ({ className }) => {
  const ticket = useSelector(selectCurrentTicket)
  const mailbox = useSelector(state => selectMailbox(state, ticket?.mailboxId))
  const score = mailbox?.preferences?.ai_quality_rating || 0

  return (
    <div
      className={cn('grui flex items-center', className)}
      css={[text.styles.textXs, text.styles.fontMedium]}
    >
      <HalfCircleGauge percent={score} className="grui mr-7" />
      {score}% knowledge score
      {/* FIXME: get kb article link */}
      <a
        href="https://help.groovehq.com/"
        className="grui ml-5"
        target="_blank"
        rel="noopener noreferrer"
        css={styles.learnLink}
      >
        Learn
      </a>
    </div>
  )
}

export default KbScoreHint
